<template>
  <v-list>
    <v-subheader>
      {{ $t('eleave.mapaNotUsed') }}
    </v-subheader>
    <v-list-item
      v-for="(record, index) in mapaRecords"
      :key="index"
    >
      <v-list-item-content>
        <v-list-item-title class="text-md-subtitle-2">
          {{ $t('Text.From') }} {{ momentWithHyphen(record.startDate).format('YYYY-MM-DD') }} {{ $t('Text.To') }} {{ momentWithHyphen(record.endDate).format('YYYY-MM-DD') }}
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action class="my-0">
        <v-btn
          small
          icon
          @click="$emit('mapaClick', mapaRecords[index])"
        >
          <v-icon
            color="grey lighten-1"
          >
            {{ mdiContentCopy }}
          </v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>

import { mapState } from 'vuex'
import { momentWithHyphen } from '@/utils/datetimeUtil'
import { mdiContentCopy } from '@mdi/js'

const staffModule = 'staff'

export default {

  data: () => {
    return {
      mdiContentCopy: mdiContentCopy
      // mapaRecords: [
      //   {
      //     startDate: '2019-08-23',
      //     endDate: '2019-08-23'
      //   },
      //   {
      //     startDate: '2019-08-26',
      //     endDate: '2019-08-30'
      //   },
      //   {
      //     startDate: '2019-09-02',
      //     endDate: '2019-09-06'
      //   },
      //   {
      //     startDate: '2019-12-26',
      //     endDate: '2019-12-27'
      //   },
      //   {
      //     startDate: '2019-12-30',
      //     endDate: '2019-12-30'
      //   }
      // ]
    }
  },
  computed: mapState({
    staff: state => state[staffModule].info,
    mapaRecords: state => state[staffModule].availableLeaveMark
  }),
  created () {
    this.$store.dispatch(staffModule + '/getAvailableLeaveMark', (new Date()).getFullYear())
  },
  methods: {
    momentWithHyphen: momentWithHyphen
  }
}
</script>
